module.exports = __webpack_public_path__ + "image-a370ad22488b.png";